import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Filmes from "./Pages/Filmes";
import Favoritos from "./Pages/Favoritos";
import Erro from "./Pages/Erro";

import Header from "./Components/Header";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/filme/:id" element={<Filmes />} />
        <Route path="/favoritos" element={<Favoritos />} />
        <Route path="*" element={<Erro />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;